import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import NewCompany from '../components/modals/NewCompany'
import TransportationServicesService from '../services/TransportationServicesService'

export default withRouter(({ match, history }) => {
  const { id } = match.params
  const [model, setModel] = useState(null)
  const [isLoading, setIsLoading] = useState(!!id)

  useEffect(() => {
    if (id) {
      TransportationServicesService.get(id)
        .then(data => {
          setModel(data)
          setIsLoading(false)
        })
        .catch(err => {
          console.error(err)
          setIsLoading(false)
        })
    }
  }, [id])

  const handleSave = (model, isUpdate) => {
    if (isUpdate) {
      return TransportationServicesService.update(model)
    } else {
      return TransportationServicesService.create(model)
    }
  }

  const handleSaveSuccess = () => {
    history.push('/library/transportation-services')
  }

  const handleClose = () => {
    history.push('/library/transportation-services')
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className="container mt-4">
      <Helmet
        title={
          id ? `Edit Transportation Service ${model?.name ? `- ${model.name}` : ''}` : 'Add Transportation Service'
        }
      />
      <NewCompany
        oldModel={model}
        onSave={handleSave}
        onSaveSuccess={handleSaveSuccess}
        onClose={handleClose}
        title="Transportation Service"
      />
    </div>
  )
})
